import React from 'react';
import {
  Typography, Container, List, ListItem, Chip, Box, Link, Button, IconButton
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import statusLabel from '../../utils/statusLabel';
import styles from './styles';
import { i18n } from '../../translate/i18n';
import { useDispatch } from 'react-redux';
import * as actions from '../../store/actions';
import getAccountablesNamesFormatted from '../../utils/getAccountablesNamesFormatted';

export interface IOldAction {
  status: string,
  deadline: string,
  actionText: string,
  accountable: {
    name: string,
  },
  accountables: {
    name: string,
    _id: string,
  }[],
  service: {
    date: string,
  }
  date: string,
  _id: string,
  question: string,
  problemText?: string,
}

export default function ServiceOldActionsPanel(props: {actions: IOldAction[], title?: string, showRefreshButton?: boolean}) {
  const dispatch = useDispatch();
  return (
    <Container style={styles.container}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between'}}>
        { props.title && <Typography style={styles.title}>{`${props.title} (${props.actions.length})`}</Typography> }
        {props.showRefreshButton && <IconButton sx={{padding: '16px'}} onClick={() => { dispatch(actions.createServiceRefreshOldActions(props.actions, props.actions[0].question))}}>
          <RefreshIcon />
        </IconButton>
        }
      </Box>
      <List style={styles.list}>
        {props.actions.map((action) => {
          const status = statusLabel(action.status, action.deadline);
          return(
            <Link
              href={`/form-action/${action._id}`}
              target="_blank"
              color='inherit'
              style={styles.link}
              key={action._id}
            >
              <ListItem style={styles.listItem} button>
                <Box style={styles.textBox}>
                  <Typography sx={[styles.text, { wordBreak: "break-word" }]}>
                    <b>{i18n.t('typographyActionExpansion.problem') as string}</b>
                    {action.problemText || '-'}
                  </Typography>
                  <Typography sx={[styles.text, { wordBreak: "break-word" }]}>
                    <b>{i18n.t('typographyActionExpansion.action') as string}</b>
                    {action.actionText}
                  </Typography>
                  <Typography style={styles.text}>
                    <b>{i18n.t('serviceOldActionsPanel.accountable') as string}</b>
                    {action.accountables?.length > 0 ? action.accountables.map(({name}) => <Chip label={name} sx={{...styles.chip, color: 'black'}}/>) : i18n.t('serviceOldActionsPanel.noAccountable') as string}
                  </Typography>
                  <Typography style={styles.text}><b>{i18n.t('serviceOldActionsPanel.deadline') as string}</b>{new Date(action.deadline).toLocaleDateString('pt-BR')}</Typography>
                  <Typography style={styles.text}><b>{i18n.t('serviceOldActionsPanel.serviceDate') as string}</b>{new Date(action.service.date).toLocaleDateString('pt-BR')}</Typography>
                </Box>
                <Chip label={status.title} style={{ ...styles.chip, backgroundColor: status.color }} />
              </ListItem>
            </Link>
          )
        })}
      </List>
    </Container>
  )
}
